import React from "react";
import { Toaster } from "sonner";
import { Helmet } from "react-helmet-async";
import { mergeTailwindClasses } from "../../helpers/tailwindClassHelper";
import Sidebar from "../../components/Layout/Sidebar";
import { CircleAlert, CircleCheckBig, CirclePause } from "lucide-react";
import { useTheme } from "../../context/ThemeContext";

const RootLayout = (props: {
  children: React.ReactNode;
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  isExpanded: boolean;
  isCollapsed: boolean;
  setIsCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { resolvedTheme } = useTheme();
  const htmlClass = resolvedTheme === "dark" ? "h-full dark" : "h-full";
  return (
    <div className={mergeTailwindClasses("h-full")}>
      <Helmet>
        <html lang="en" className={htmlClass} />
        <title>Kyva - Chat with Kyva</title>
        <meta
          name="description"
          content="Kyva is an AI powered chatbot that is connected to the internet."
        />
       <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover" />

      </Helmet>
      <Sidebar
        setIsExpanded={props.setIsExpanded}
        isExpanded={props.isExpanded}
        isCollapsed={props.isCollapsed}
        setIsCollapsed={props.setIsCollapsed}
      >
        {props.children}
      </Sidebar>
      <Toaster
        icons={{
          success: <CircleCheckBig className="pr-2" />,
          info: <CirclePause className="pr-2" />,
          warning: <CircleAlert className="pr-2" />,
          error: <CircleAlert className="pr-2" />,
        }}
        toastOptions={{
          unstyled: true,
          duration: 3000,
          closeButton: false,
          classNames: {
            success:
              "bg-surface-overlay text-green-600 dark:text-green-400 ring-1 ring-black/5 dark:ring-gray-700 shadow-lg text-sm rounded-lg p-4 flex flex-row items-center space-x-2",
            error:
              "bg-surface-overlay text-violet-600 dark:text-violet-300 ring-1 ring-black/5 dark:ring-gray-700 shadow-lg text-sm rounded-lg p-4 flex flex-row items-center space-x-2",
            info: "bg-surface-overlay text-violet-600 dark:text-violet-300 ring-1 ring-black/5 dark:ring-gray-700 shadow-lg text-sm rounded-lg p-4 flex flex-row items-center space-x-2",
          },
        }}
        position="bottom-right"
      />
    </div>
  );
};

export default RootLayout;
